var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',[_c('service-provider-chip',{attrs:{"item":_vm.sp,"with-id":"","color":"yellow","outlined":_vm.outlined}}),_c('v-spacer'),_c('v-switch',{staticClass:"v-input--reverse",attrs:{"disabled":_vm.disabled,"input-value":_vm.value,"small":"","dense":""},on:{"change":(val) => _vm.$emit('change', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }